import SwitchOrganizations from 'features/organizations/components/organisms/SwitchOrganizations/SwitchOrganizations';

export default SwitchOrganizations;
